import React, { useState } from "react";
import { Table, Typography } from "antd";
import { PieChart, Pie, Cell, ResponsiveContainer, Tooltip, Legend } from "recharts";

const { Title, Text } = Typography;

const departmentsData = [
    {
        key: "1",
        department: "Software Development",
        employees: 3,
        avgHours: 4.0,
        workingHours: 5.0,
        color: "#FF4D4F",
    },
    {
        key: "2",
        department: "Software Developer",
        employees: 5,
        avgHours: 44.0,
        workingHours: 32.0,
        color: "#52C41A",
    },
    {
        key: "3",
        department: "QA Department",
        employees: 6,
        avgHours: 22.0,
        workingHours: 34.0,
        color: "#1890FF",
    },
];

const AvgWorkHoursLeaderboard: React.FC = () => {

    // Pie Chart Data
    const pieData = departmentsData.map((dept) => ({
        name: dept.department,
        value: dept.avgHours,
        color: dept.color,
    }));

    // Table Columns
    const columns = [
        { title: "Department", dataIndex: "department", key: "department", render: (text) => <Text strong>{text}</Text> },
        { title: "Employees", dataIndex: "employees", key: "employees" },
        { title: "Avg. Hours", dataIndex: "avgHours", key: "avgHours", render: (text) => `${text.toFixed(2)} hrs` },
        { title: "Working Hours", dataIndex: "workingHours", key: "workingHours", render: (text) => `${text.toFixed(2)} hrs` },
    ];

    const COLORS = ["#FF9F00", "#00BFFF", "#9ACD32", "#FF69B4"];


    return (
        <div style={{ display: "flex", gap: "20px" }}>
            <div style={{ flex: 2 }}>
                <Table dataSource={departmentsData} columns={columns} pagination={false} />
            </div>

            <div style={{ flex: 1, textAlign: "center" }}>
                <Title level={5}>Average Working Hours</Title>
                <ResponsiveContainer width="100%" height={200}>
                    <PieChart>
                        <Pie data={pieData} dataKey="value" innerRadius={30} outerRadius={80} label>
                            {pieData.map((entry, index) => (
                                <Cell key={`cell-${index}`} fill={entry.color} />
                            ))}
                        </Pie>
                        <Tooltip />
                        <Legend />
                    </PieChart>
                </ResponsiveContainer>
                <Text strong>0 hrs Per Day</Text>
            </div>
        </div>
    );
};

export default AvgWorkHoursLeaderboard;
